import BookingSuccessModal from './BookingSuccessModal';
import GroupBooking from './GroupBooking';
import RoomStayBooking from './RoomStayBooking';
import CorporateBooking from './CorporateBooking';
import WeddingBooking from './WeddingBooking';
import PaymentModal from './PaymentModal';
import React, { useState, useEffect, useCallback, useRef } from 'react';

const API = 'https://api.botanix.in/api';

const C = {
 bg: '#0F1117', surface: '#1A1D27', surface2: '#22263A',
 border: 'rgba(255,255,255,.08)', border2: 'rgba(255,255,255,.14)',
 text: '#F0F2FF', text2: '#A0A8C0', text3: '#606880',
 accent: '#3AAF58', blue: '#2563A8', blueLight: '#3B82F6',
 red: '#E05050', redBg: 'rgba(224,80,80,.10)', redBorder: 'rgba(224,80,80,.25)',
 amber: '#D4840F', amberBg: 'rgba(212,132,15,.10)', amberBorder: 'rgba(212,132,15,.25)',
 green: '#3AAF58',
};

const inr = n => '₹' + Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });
const fmtDate = d => d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
const daysBetween = (a, b) => { if (!a || !b) return 1; return Math.max(1, Math.ceil((new Date(b) - new Date(a)) / 86400000)); };

const PRICING = {
 rooms: [
 { id:'forest_view', name:'Forest View Room', baseRate:4500, extraBed:1200, gstRate:12 },
 { id:'lakeside_suite', name:'Lakeside Suite', baseRate:8500, extraBed:1500, gstRate:12 },
 { id:'canopy_cottage', name:'Canopy Cottage', baseRate:12000, extraBed:2000, gstRate:18 },
 { id:'jungle_tent', name:'Jungle Tent', baseRate:3000, extraBed:1000, gstRate:12 },
 { id:'driver_room', name:'Driver / Staff Room', baseRate:1500, extraBed:0, gstRate:0 },
 ],
 mealPlans: [
 { id:'cp', name:'CP – Breakfast', ratePerPax:800 },
 { id:'map', name:'MAP – Breakfast + Dinner', ratePerPax:1500 },
 { id:'ap', name:'AP – All Inclusive (3 meals)', ratePerPax:2200 },
 { id:'lunch_only', name:'Lunch Only', ratePerPax:600 },
 { id:'dinner_only', name:'Dinner Only', ratePerPax:800 },
 { id:'high_tea', name:'High Tea', ratePerPax:350 },
 { id:'welcome_drink',name:'Welcome Drink', ratePerPax:120 },
 { id:'buffet_veg', name:'Buffet Lunch – Veg', ratePerPax:650 },
 { id:'buffet_nonveg',name:'Buffet Lunch – Non-Veg', ratePerPax:850 },
 ],
 packages: [
 { id:'corp_std', name:'Corporate Day Picnic – Standard', ratePerPax:1800, gstRate:18, includes:'Welcome Drink, Breakfast, Buffet Lunch, High Tea, Activities' },
 { id:'corp_prem', name:'Corporate Day Picnic – Premium', ratePerPax:2800, gstRate:18, includes:'All Standard + DJ, Conference Hall, AV Setup, Bonfire' },
 { id:'school', name:'School Picnic Package', ratePerPax:950, gstRate:5, includes:'Welcome Drink, Lunch, 3 Activities' },
 { id:'weekend', name:'Weekend Room Package', ratePerPax:7500, gstRate:12, includes:'Room + Breakfast + Dinner + 1 Activity' },
 { id:'mice', name:'MICE Conference Package', ratePerPax:3500, gstRate:18, includes:'Hall, AV, 3 Meals, Team Activities' },
 ],
 venues: [
 { id:'central_lawn', name:'Central Lawn', baseRate:85000, capacity:1000, gstRate:18 },
 { id:'amphitheatre', name:'Jungle Amphitheatre', baseRate:55000, capacity:500, gstRate:18 },
 { id:'conf_hall_a', name:'Conference Hall A', baseRate:15000, capacity:100, gstRate:18 },
 { id:'conf_hall_b', name:'Conference Hall B', baseRate:8000, capacity:50, gstRate:18 },
 { id:'poolside', name:'Poolside Deck', baseRate:25000, capacity:150, gstRate:18 },
 { id:'banquet', name:'Banquet Hall', baseRate:45000, capacity:300, gstRate:18 },
 ],
 activities: [
 { id:'obstacle', name:'Obstacle Course', pricePerPax:350, gstRate:18 },
 { id:'rappelling', name:'Rappelling', pricePerPax:500, gstRate:18 },
 { id:'camel', name:'Camel Cart Ride', pricePerPax:200, gstRate:18 },
 { id:'bullock', name:'Bullock Cart Ride', pricePerPax:150, gstRate:18 },
 { id:'nature_walk', name:'Nature Walk', pricePerPax:100, gstRate:18 },
 { id:'zipline', name:'Zip Line', pricePerPax:400, gstRate:18 },
 { id:'archery', name:'Archery', pricePerPax:250, gstRate:18 },
 { id:'bonfire', name:'Bonfire & DJ Night', pricePerPax:300, gstRate:18 },
 ],
 addons: [
 { id:'dj_std', name:'DJ – Standard', price:25000, unit:'per event', gstRate:18 },
 { id:'dj_prem', name:'DJ – Premium', price:45000, unit:'per event', gstRate:18 },
 { id:'liveband', name:'Live Band', price:75000, unit:'per event', gstRate:18 },
 { id:'raindance', name:'Rain Dance', price:8000, unit:'per event', gstRate:18 },
 { id:'bar', name:'Bar Counter', price:35000, unit:'per event', gstRate:18 },
 { id:'mocktail', name:'Mocktail Counter', price:12000, unit:'per event', gstRate:18 },
 { id:'chaat', name:'Chaat Counter', price:8000, unit:'per event', gstRate:18 },
 { id:'projector', name:'Projector & Screen', price:5000, unit:'per day', gstRate:18 },
 { id:'led', name:'LED Screen', price:18000, unit:'per day', gstRate:18 },
 { id:'pa', name:'PA System', price:8000, unit:'per day', gstRate:18 },
 { id:'stage', name:'Stage Setup', price:30000, unit:'per event', gstRate:18 },
 { id:'lighting', name:'Lighting Package', price:25000, unit:'per event', gstRate:18 },
 { id:'flowers', name:'Flower Decor', price:40000, unit:'per event', gstRate:18 },
 { id:'photo', name:'Photography', price:20000, unit:'per event', gstRate:18 },
 { id:'video', name:'Videography', price:30000, unit:'per event', gstRate:18 },
 { id:'paintball', name:'Paintball', price:600, unit:'per pax', gstRate:18 },
 { id:'atv', name:'ATV Ride', price:800, unit:'per pax', gstRate:18 },
 ],
};

const BOOKING_TYPES = [
 { id:'room', label:' Room Stay', sections:['rooms','mealPlans','activities','addons'] },
 { id:'day_picnic', label:' Day Picnic', sections:['packages','mealPlans','activities','addons'] },
 { id:'event', label:' Event / Wedding', sections:['venues','mealPlans','activities','addons'] },
 { id:'corporate', label:' Corporate / MICE', sections:['packages','venues','mealPlans','activities','addons'] },
 { id:'group', label:'Group Booking', sections:['packages','mealPlans','activities','addons'] },
 { id:'school', label:' School Picnic', sections:['packages','mealPlans','activities'] },
];

const STATUSES = ['Confirmed','Tentative','Cancelled','Checked In','Checked Out','No Show'];
const STATUS_COLORS = {
 'Confirmed': '#3AAF58',
 'Tentative': '#D4840F', 
 'Cancelled': '#E05050',
 'Checked In': '#2563A8',
 'Checked Out': '#A0A8C0',
 'No Show': '#E05050',
 'Deleted': '#606880',
 'Rebooked': '#8060C0', 'Confirmed':'#3AAF58','Tentative':'#D4840F','Cancelled':'#E05050','Checked In':'#2563A8','Checked Out':'#A0A8C0','No Show':'#E05050' };
const SOURCES = ['Direct','Phone','Email','Walk-in','Website','OTA','WhatsApp','Corporate','Referral'];

const inp = { width:'100%', padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:'#F0F2FF', fontSize:14, boxSizing:'border-box', outline:'none' };
const sel = { ...inp, cursor:'pointer' };
const lbl = (t) => <label style={{ display:'block', fontSize:12, color:'#A0A8C0', marginBottom:5, fontWeight:600 }}>{t}</label>;

// ── BOOKING MODAL — all state in one component, no sub-components ─────────────
function BookingModal({ onClose, onSave, userRole }) {
 const isSales = userRole === 'SALES';
 const maxDisc = isSales ? 5 : 100;

 const [step, setStep] = useState(1);
 const [saving, setSaving] = useState(false);
 const [error, setError] = useState('');

 // Step 1 state
 const [bookingType, setBookingType] = useState('');
 const [guestName, setGuestName] = useState('');
 const [guestPhone, setGuestPhone] = useState('');
 const [guestEmail, setGuestEmail] = useState('');
 const [company, setCompany] = useState('');
 const [gstNum, setGstNum] = useState('');
 const [startDate, setStartDate] = useState('');
 const [endDate, setEndDate] = useState('');
 const [pax, setPax] = useState(1);
 const [status, setStatus] = useState('Confirmed');
 const [source, setSource] = useState('Direct');
 const [salesperson, setSalesperson] = useState('');
 const [nationality, setNationality] = useState('Indian');
 const [childrenBelow5, setChildrenBelow5] = useState(0);
 const [children6to15, setChildren6to15] = useState(0);
 const [childRate, setChildRate] = useState(60);
 const [petCount, setPetCount] = useState(0);
 const [petRate, setPetRate] = useState(500);
 const [dayOutingPax, setDayOutingPax] = useState(0);
 const [dayOutingRate, setDayOutingRate] = useState(1500);
 const [customPackageName, setCustomPackageName] = useState('');
 const [customPackageAmount, setCustomPackageAmount] = useState(0);
 const [gstMode, setGstMode] = useState('split');
 const [gstSingleRate, setGstSingleRate] = useState(12);
 const [gstFoodPct, setGstFoodPct] = useState(5);
 const [gstFoodShare, setGstFoodShare] = useState(70);
 const [gstServicePct, setGstServicePct] = useState(18);

 // Step 2 state
 const [selRooms, setSelRooms] = useState([]);
 const [selPackage, setSelPackage] = useState('');
 const [selMeals, setSelMeals] = useState([]);
 const [selVenues, setSelVenues] = useState([]);
 const [selActivities, setSelActivities] = useState([]);
 const [selAddons, setSelAddons] = useState([]);

 // Step 3 state
 const [discountPct, setDiscountPct] = useState(0);
 const [advance, setAdvance] = useState(0);
 const [notes, setNotes] = useState('');

 const nights = daysBetween(startDate, endDate);
 const btype = BOOKING_TYPES.find(t => t.id === bookingType);
 const sections = btype?.sections || [];

 // ── Calculate total ─────────────────────────────────────────────────────
 const calcTotal = () => {
 let subtotal = 0;
 const breakdown = [];
 selRooms.forEach(sr => {
 const r = PRICING.rooms.find(x => x.id === sr.id);
 if (!r) return;
 const amt = r.baseRate * sr.qty * nights + (sr.extraBed||0) * r.extraBed * nights;
 subtotal += amt;
 breakdown.push({ label:`${r.name} ×${sr.qty} × ${nights} night(s)`, amount:amt });
 });
 if (selPackage) {
 const p = PRICING.packages.find(x => x.id === selPackage);
 if (p) { const amt = p.ratePerPax * pax; subtotal += amt; breakdown.push({ label:`${p.name} ×${pax} pax`, amount:amt }); }
 }
 selMeals.forEach(id => {
 const m = PRICING.mealPlans.find(x => x.id === id);
 if (!m) return;
 const amt = m.ratePerPax * pax; subtotal += amt; breakdown.push({ label:`${m.name} ×${pax} pax`, amount:amt });
 });
 selVenues.forEach(sv => {
 const v = PRICING.venues.find(x => x.id === sv.id);
 if (!v) return;
 const amt = v.baseRate * (sv.days||1); subtotal += amt; breakdown.push({ label:`${v.name} × ${sv.days||1} day(s)`, amount:amt });
 });
 selActivities.forEach(id => {
 const a = PRICING.activities.find(x => x.id === id);
 if (!a) return;
 const amt = a.pricePerPax * pax; subtotal += amt; breakdown.push({ label:`${a.name} ×${pax} pax`, amount:amt });
 });
 selAddons.forEach(id => {
 const a = PRICING.addons.find(x => x.id === id);
 if (!a) return;
 const amt = a.unit === 'per pax' ? a.price * pax : a.price;
 subtotal += amt; breakdown.push({ label:`${a.name}`, amount:amt });
 });
 // Pet charges
 if (petCount > 0 && petRate > 0) {
   const petAmt = petCount * petRate * (nights || 1);
   subtotal += petAmt;
   breakdown.push({ label:`Pet Charges ×${petCount} × ${nights||1} night(s)`, amount:petAmt });
 }
 // Day outing
 if (dayOutingPax > 0 && dayOutingRate > 0) {
   const outAmt = dayOutingPax * dayOutingRate;
   subtotal += outAmt;
   breakdown.push({ label:`Day Outing ×${dayOutingPax} pax @ Rs.${dayOutingRate}`, amount:outAmt });
 }
 // Custom package
 if (customPackageAmount > 0) {
   subtotal += customPackageAmount;
   breakdown.push({ label:customPackageName || 'Custom Package', amount:customPackageAmount });
 }
 // Child charges
 if (children6to15 > 0) {
   const childAmt = (subtotal * (childRate/100) * children6to15) / (pax || 1);
   subtotal += childAmt;
   breakdown.push({ label:`Children 6-15 yrs ×${children6to15} @ ${childRate}% of adult rate`, amount:childAmt });
 }
 const discAmt = Math.round(subtotal * discountPct / 100);
 const afterDisc = subtotal - discAmt;
 // GST calculation
 let gstAmt = 0;
 let gstBreakdown = '';
 if (gstMode === 'split') {
   const foodPortion = afterDisc * (gstFoodShare / 100);
   const servicePortion = afterDisc * ((100 - gstFoodShare) / 100);
   const foodGst = Math.round(foodPortion * gstFoodPct / 100);
   const serviceGst = Math.round(servicePortion * gstServicePct / 100);
   gstAmt = foodGst + serviceGst;
   gstBreakdown = `${gstFoodPct}% on ${gstFoodShare}% (Rs.${foodGst}) + ${gstServicePct}% on ${100-gstFoodShare}% (Rs.${serviceGst})`;
 } else {
   gstAmt = Math.round(afterDisc * gstSingleRate / 100);
   gstBreakdown = `${gstSingleRate}% flat`;
 }
 return { subtotal, discAmt, gstAmt, gstBreakdown, total: afterDisc + gstAmt, breakdown };
 };

 const { subtotal, discAmt, gstAmt, gstBreakdown, total, breakdown } = calcTotal();
 const approvalRequired = discountPct > maxDisc;

 const handleSave = async () => {
 setSaving(true); setError('');
 try {
 const res = await fetch(`${API}/bookings`, {
 method:'POST', headers:{'Content-Type':'application/json'},
 body: JSON.stringify({
 guest_name: guestName, nationality, children_below5: childrenBelow5, children_6to15: children6to15, child_rate: childRate, pet_count: petCount, pet_rate: petRate, day_outing_pax: dayOutingPax, day_outing_rate: dayOutingRate, custom_package_name: customPackageName, custom_package_amount: customPackageAmount, gst_amount: gstAmt, gst_breakdown: gstBreakdown, guest_phone: guestPhone, guest_email: guestEmail,
 booking_type: btype?.label || bookingType,
 start_date: startDate, end_date: endDate || startDate,
 pax_count: pax, booking_status: status,
 total_amount: total, advance_paid: advance, balance_amount: total - advance,
 salesperson, source, discount_pct: discountPct,
 notes: notes + (breakdown.length ? '\nBreakdown:\n' + breakdown.map(b=>`${b.label}: ${inr(b.amount)}`).join('\n') : '') +
 (selMeals.length ? `<<<ROOM_DATA:${JSON.stringify({ selMeals, mealPax: pax })}>>>` : '') +
 (selPackage ? `<<<PACKAGE_DATA:${JSON.stringify({ selPackage, pax })}>>>` : ''),
 }),
 });
 const data = await res.json();
 if (!res.ok) throw new Error(data.error || 'Failed');
 onSave(); onClose();
 } catch(err) { setError(err.message); }
 finally { setSaving(false); }
 };

 const goNext = () => {
 if (step===1 && !bookingType) { setError('Select a booking type'); return; }
 if (step===1 && !guestName.trim()) { setError('Enter guest name'); return; }
 if (step===1 && !startDate) { setError('Select check-in date'); return; }
 setError(''); setStep(s => s+1);
 };

 return (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.75)', zIndex:1000, display:'flex', alignItems:'flex-start', justifyContent:'center', padding:16, overflowY:'auto' }}>
 <div style={{ background:'#1A1D27', border:'1px solid rgba(255,255,255,.14)', borderRadius:16, width:'100%', maxWidth:860, marginTop:20, marginBottom:20 }}>

 {/* Header */}
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'18px 24px', borderBottom:'1px solid rgba(255,255,255,.08)' }}>
 <div style={{ fontWeight:700, fontSize:16, color:'#F0F2FF' }}>New Booking</div>
 <button onClick={onClose} style={{ background:'none', border:'none', color:'#606880', fontSize:20, cursor:'pointer' }}></button>
 </div>

 {/* Step tabs */}
 <div style={{ display:'flex', gap:0, padding:'0 24px', borderBottom:'1px solid rgba(255,255,255,.08)' }}>
 {[{n:1,label:'1. Type & Guest'},{n:2,label:'2. Select Services'},{n:3,label:'3. Pricing & Confirm'}].map(s => (
 <button key={s.n} onClick={() => s.n <= step ? setStep(s.n) : null}
 style={{ padding:'12px 20px', background:'transparent', border:'none', borderBottom:`2px solid ${step===s.n?C.accent:'transparent'}`, color:step===s.n?C.accent:step>s.n?C.text2:C.text3, cursor:'pointer', fontSize:13, fontWeight:600 }}>
 {s.label}
 </button>
 ))}
 </div>

 {/* Content */}
 <div style={{ padding:24 }}>
 {error && <div style={{ padding:'10px 14px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:8, color:C.red, fontSize:13, marginBottom:16 }}>{error}</div>}

 {/* ── STEP 1 ── */}
 {step === 1 && (
 <div>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}>Select Booking Type</div>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10, marginBottom:24 }}>
 {BOOKING_TYPES.map(bt => (
 <button key={bt.id} onClick={() => setBookingType(bt.id)}
 style={{ padding:'14px 10px', background:bookingType===bt.id?`${C.accent}22`:C.surface2, border:`2px solid ${bookingType===bt.id?C.accent:C.border}`, borderRadius:10, color:bookingType===bt.id?C.accent:C.text2, cursor:'pointer', fontSize:13, fontWeight:600, textAlign:'center' }}>
 {bt.label}
 </button>
 ))}
 </div>

 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}>Guest Details</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:20 }}>
 <div style={{ gridColumn:'span 2' }}>
 {lbl('Guest / Company Name *')}
 <input style={inp} type="text" value={guestName} onChange={e => setGuestName(e.target.value)} placeholder="Full name or company" />
 </div>
 <div>{lbl('Phone')}<input style={inp} type="text" value={guestPhone} onChange={e => setGuestPhone(e.target.value)} placeholder="Mobile number" /></div>
 <div>{lbl('Email')}<input style={inp} type="email" value={guestEmail} onChange={e => setGuestEmail(e.target.value)} placeholder="Email address" /></div>
 <div>{lbl('Company (B2B)')}<input style={inp} type="text" value={company} onChange={e => setCompany(e.target.value)} placeholder="Company name" /></div>
 <div>{lbl('GST Number')}<input style={inp} type="text" value={gstNum} onChange={e => setGstNum(e.target.value)} placeholder="For B2B invoicing" /></div>
 </div>

 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}>Booking Details</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div>{lbl('Check-in / Event Date *')}<input style={inp} type="date" value={startDate} onChange={e => setStartDate(e.target.value)} /></div>
 <div>{lbl('Check-out Date')}<input style={inp} type="date" value={endDate} onChange={e => setEndDate(e.target.value)} /></div>
 <div>{lbl('No. of Pax *')}<input style={inp} type="number" min={1} value={pax} onChange={e => setPax(parseInt(e.target.value)||1)} /></div>
 <div>{lbl('Status')}<select style={sel} value={status} onChange={e => setStatus(e.target.value)}>{STATUSES.map(s=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={s}>{s}</option>)}</select></div>
 <div>{lbl('Source')}<select style={sel} value={source} onChange={e => setSource(e.target.value)}>{SOURCES.map(s=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={s}>{s}</option>)}</select></div>
 <div>{lbl('Salesperson')}<input style={inp} type="text" value={salesperson} onChange={e => setSalesperson(e.target.value)} placeholder="Your name" /></div>
 <div>{lbl('Nationality')}<select style={sel} value={nationality} onChange={e => setNationality(e.target.value)}><option style={{background:'#0F2040',color:'#F0F2FF'}}>Indian</option><option style={{background:'#0F2040',color:'#F0F2FF'}}>Foreign</option></select></div>
 </div>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, margin:'16px 0 12px', textTransform:'uppercase', letterSpacing:'.05em' }}>Children</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:14, marginBottom:8 }}>
   <div>{lbl('Below 5 Years (Free)')}<input style={inp} type="number" min={0} value={childrenBelow5} onChange={e=>setChildrenBelow5(parseInt(e.target.value)||0)} /></div>
   <div>{lbl('6-15 Years (Chargeable)')}<input style={inp} type="number" min={0} value={children6to15} onChange={e=>setChildren6to15(parseInt(e.target.value)||0)} /></div>
   <div>{lbl('Child Rate (% of adult)')}<input style={inp} type="number" min={0} max={100} value={childRate} onChange={e=>setChildRate(parseInt(e.target.value)||60)} /></div>
 </div>
 <div style={{ fontSize:11, color:C.text3, marginBottom:16 }}>Children below 5 are free. Children 6-15 charged at {childRate}% of adult rate.</div>
 </div>
 )}

 {/* ── STEP 2 ── */}
 {step === 2 && (
 <div>
 {/* ROOMS */}
 {sections.includes('rooms') && (
 <div style={{ marginBottom:24 }}>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}> Rooms ({nights} night{nights>1?'s':''})</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
 {PRICING.rooms.map(room => {
 const sr = selRooms.find(r => r.id === room.id);
 return (
 <div key={room.id} style={{ padding:14, background:sr?`${C.accent}12`:C.surface2, border:`1px solid ${sr?C.accent:C.border}`, borderRadius:10 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:sr?10:0 }}>
 <div>
 <div style={{ fontWeight:600, fontSize:13, color:C.text }}>{room.name}</div>
 <div style={{ fontSize:12, color:C.accent, marginTop:2 }}>{inr(room.baseRate)}/night</div>
 </div>
 <button onClick={() => setSelRooms(p => p.find(r=>r.id===room.id) ? p.filter(r=>r.id!==room.id) : [...p,{id:room.id,qty:1,extraBed:0}])}
 style={{ padding:'5px 14px', background:sr?C.accent:'transparent', border:`1px solid ${sr?C.accent:C.border2}`, borderRadius:7, color:sr?'#fff':C.text2, cursor:'pointer', fontSize:12, fontWeight:600 }}>
 {sr ? ' Selected' : '+ Add'}
 </button>
 </div>
 {sr && (
 <div style={{ display:'flex', gap:10 }}>
 <div style={{ flex:1 }}>
 <label style={{ fontSize:11, color:C.text3 }}>Rooms</label>
 <input type="number" min={1} value={sr.qty} onChange={e => setSelRooms(p=>p.map(r=>r.id===room.id?{...r,qty:parseInt(e.target.value)||1}:r))}
 style={{ ...inp, padding:'6px 10px', fontSize:13, marginTop:3 }} />
 </div>
 {room.extraBed>0 && (
 <div style={{ flex:1 }}>
 <label style={{ fontSize:11, color:C.text3 }}>Extra Bed</label>
 <input type="number" min={0} value={sr.extraBed} onChange={e => setSelRooms(p=>p.map(r=>r.id===room.id?{...r,extraBed:parseInt(e.target.value)||0}:r))}
 style={{ ...inp, padding:'6px 10px', fontSize:13, marginTop:3 }} />
 </div>
 )}
 <div style={{ flex:1 }}>
 <label style={{ fontSize:11, color:C.text3 }}>Total</label>
 <div style={{ fontSize:13, fontWeight:700, color:C.accent, marginTop:9 }}>{inr(room.baseRate*sr.qty*nights+(sr.extraBed||0)*room.extraBed*nights)}</div>
 </div>
 </div>
 )}
 </div>
 );
 })}
 </div>
 </div>
 )}

 {/* PACKAGES */}
 {sections.includes('packages') && (
 <div style={{ marginBottom:24 }}>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}> Packages</div>
 <div style={{ display:'grid', gap:8 }}>
 {PRICING.packages.map(pkg => (
 <div key={pkg.id} onClick={() => setSelPackage(selPackage===pkg.id?'':pkg.id)}
 style={{ padding:14, background:selPackage===pkg.id?`${C.accent}12`:C.surface2, border:`1px solid ${selPackage===pkg.id?C.accent:C.border}`, borderRadius:10, cursor:'pointer' }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
 <div>
 <div style={{ fontWeight:600, fontSize:13, color:C.text }}>{pkg.name}</div>
 <div style={{ fontSize:11, color:C.text3, marginTop:3 }}>{pkg.includes}</div>
 </div>
 <div style={{ textAlign:'right' }}>
 <div style={{ fontWeight:700, color:C.accent }}>{inr(pkg.ratePerPax)}/pax</div>
 <div style={{ fontSize:12, color:C.text3 }}>= {inr(pkg.ratePerPax*pax)}</div>
 </div>
 </div>
 </div>
 ))}
 </div>
 </div>
 )}

 {/* MEAL PLANS */}
 {sections.includes('mealPlans') && (
 <div style={{ marginBottom:24 }}>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}> Meal Plans</div>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:8 }}>
 {PRICING.mealPlans.map(meal => {
 const selected = selMeals.includes(meal.id);
 return (
 <div key={meal.id} onClick={() => setSelMeals(p => p.includes(meal.id)?p.filter(x=>x!==meal.id):[...p,meal.id])}
 style={{ padding:12, background:selected?`${C.accent}12`:C.surface2, border:`1px solid ${selected?C.accent:C.border}`, borderRadius:10, cursor:'pointer', textAlign:'center' }}>
 <div style={{ fontWeight:600, fontSize:12, color:C.text, marginBottom:4 }}>{meal.name}</div>
 <div style={{ fontSize:12, color:C.accent }}>{inr(meal.ratePerPax)}/pax</div>
 {selected && <div style={{ fontSize:11, color:C.accent, fontWeight:700, marginTop:4 }}>= {inr(meal.ratePerPax*pax)}</div>}
 </div>
 );
 })}
 </div>
 </div>
 )}

 {/* VENUES */}
 {sections.includes('venues') && (
 <div style={{ marginBottom:24 }}>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}> Venues</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
 {PRICING.venues.map(venue => {
 const sv = selVenues.find(v=>v.id===venue.id);
 return (
 <div key={venue.id} style={{ padding:12, background:sv?`${C.accent}12`:C.surface2, border:`1px solid ${sv?C.accent:C.border}`, borderRadius:10 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:sv?8:0 }}>
 <div>
 <div style={{ fontWeight:600, fontSize:13, color:C.text }}>{venue.name}</div>
 <div style={{ fontSize:11, color:C.text3 }}>Cap: {venue.capacity} · {inr(venue.baseRate)}/day</div>
 </div>
 <button onClick={() => setSelVenues(p=>p.find(v=>v.id===venue.id)?p.filter(v=>v.id!==venue.id):[...p,{id:venue.id,days:1}])}
 style={{ padding:'4px 12px', background:sv?C.accent:'transparent', border:`1px solid ${sv?C.accent:C.border2}`, borderRadius:6, color:sv?'#fff':C.text2, cursor:'pointer', fontSize:11 }}>
 {sv?'':'+'}
 </button>
 </div>
 {sv && (
 <div style={{ display:'flex', alignItems:'center', gap:8 }}>
 <label style={{ fontSize:11, color:C.text3 }}>Days:</label>
 <input type="number" min={1} value={sv.days} onChange={e=>setSelVenues(p=>p.map(v=>v.id===venue.id?{...v,days:parseInt(e.target.value)||1}:v))}
 style={{ ...inp, width:60, padding:'4px 8px', fontSize:12 }} />
 <span style={{ fontSize:12, color:C.accent, fontWeight:700 }}>= {inr(venue.baseRate*sv.days)}</span>
 </div>
 )}
 </div>
 );
 })}
 </div>
 </div>
 )}

 {/* ACTIVITIES */}
 {sections.includes('activities') && (
 <div style={{ marginBottom:24 }}>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}> Activities</div>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:8 }}>
 {PRICING.activities.map(act => {
 const selected = selActivities.includes(act.id);
 return (
 <div key={act.id} onClick={()=>setSelActivities(p=>p.includes(act.id)?p.filter(x=>x!==act.id):[...p,act.id])}
 style={{ padding:10, background:selected?`${C.accent}12`:C.surface2, border:`1px solid ${selected?C.accent:C.border}`, borderRadius:10, cursor:'pointer', textAlign:'center' }}>
 <div style={{ fontWeight:600, fontSize:12, color:C.text, marginBottom:4 }}>{act.name}</div>
 <div style={{ fontSize:12, color:C.accent }}>{inr(act.pricePerPax)}/pax</div>
 {selected && <div style={{ fontSize:11, color:C.accent, fontWeight:700 }}>= {inr(act.pricePerPax*pax)}</div>}
 </div>
 );
 })}
 </div>
 </div>
 )}

 {/* ADD-ONS */}
 {sections.includes('addons') && (
 <div style={{ marginBottom:24 }}>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}> Add-ons</div>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:8 }}>
 {PRICING.addons.map(addon => {
 const selected = selAddons.includes(addon.id);
 const amt = addon.unit==='per pax' ? addon.price*pax : addon.price;
 return (
 <div key={addon.id} onClick={()=>setSelAddons(p=>p.includes(addon.id)?p.filter(x=>x!==addon.id):[...p,addon.id])}
 style={{ padding:10, background:selected?`${C.accent}12`:C.surface2, border:`1px solid ${selected?C.accent:C.border}`, borderRadius:10, cursor:'pointer' }}>
 <div style={{ fontWeight:600, fontSize:12, color:C.text, marginBottom:3 }}>{addon.name}</div>
 <div style={{ fontSize:11, color:C.text3, marginBottom:3 }}>{addon.unit}</div>
 <div style={{ fontSize:12, color:C.accent }}>{inr(addon.price)}</div>
 {selected && <div style={{ fontSize:11, color:C.accent, fontWeight:700 }}>= {inr(amt)}</div>}
 </div>
 );
 })}
 </div>
 </div>
 )}
 </div>
 )}

 {/* ── STEP 3 ── */}
 {step === 3 && (
 <div>
 {/* Breakdown */}
 <div style={{ background:C.surface2, borderRadius:12, padding:18, marginBottom:20 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:14 }}> Price Breakdown</div>
 {breakdown.length===0 && <div style={{ color:C.text3, fontSize:13 }}>No items selected — booking will be created with manual pricing</div>}
 {breakdown.map((b,i) => (
 <div key={i} style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:8, color:C.text2 }}>
 <span>{b.label}</span><span style={{ fontWeight:600, color:C.text }}>{inr(b.amount)}</span>
 </div>
 ))}
 <div style={{ borderTop:`1px solid ${C.border}`, paddingTop:10, marginTop:8 }}>
 <div style={{ display:'flex', justifyContent:'space-between', fontSize:14, fontWeight:700, color:C.text, marginBottom:6 }}>
 <span>Subtotal</span><span>{inr(subtotal)}</span>
 </div>
 {discountPct>0 && (
 <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, color:C.amber, marginBottom:6 }}>
 <span>Discount ({discountPct}%)</span><span>- {inr(discAmt)}</span>
 </div>
 )}
 <div style={{ display:'flex', justifyContent:'space-between', fontSize:20, fontWeight:900, color:C.accent, borderTop:`1px solid ${C.border}`, paddingTop:10, marginTop:6 }}>
 <span>Total</span><span>{inr(total)}</span>
 </div>
 </div>
 </div>

 {/* Discount */}
 <div style={{ background:C.surface2, borderRadius:12, padding:18, marginBottom:20 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:14 }}> Discount {isSales?`(Max ${maxDisc}%)`:''}</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div>
 {lbl(`Discount %${isSales?` — max ${maxDisc}%`:''}`)}
 <input style={inp} type="number" min={0} max={isSales?maxDisc:100} value={discountPct} onChange={e=>setDiscountPct(parseFloat(e.target.value)||0)} />
 </div>
 <div>{lbl('Advance Paid (Rs)')}<input style={inp} type="number" min={0} value={advance} onChange={e => setAdvance(parseFloat(e.target.value)||0)} placeholder="0" /></div>
 </div>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, margin:'16px 0 12px', textTransform:'uppercase', letterSpacing:'.05em' }}>Additional Charges</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:12 }}>
   <div>{lbl('No. of Pets')}<input style={inp} type="number" min={0} value={petCount} onChange={e=>setPetCount(parseInt(e.target.value)||0)} /></div>
   <div>{lbl('Pet Charge per Night (Rs)')}<input style={inp} type="number" min={0} value={petRate} onChange={e=>setPetRate(parseInt(e.target.value)||500)} /></div>
   <div>{lbl('Day Outing Pax')}<input style={inp} type="number" min={0} value={dayOutingPax} onChange={e=>setDayOutingPax(parseInt(e.target.value)||0)} /></div>
   <div>{lbl('Day Outing Rate per Pax (Rs)')}<input style={inp} type="number" min={0} value={dayOutingRate} onChange={e=>setDayOutingRate(parseInt(e.target.value)||1500)} /></div>
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:12 }}>
   <div>{lbl('Custom Package Name')}<input style={inp} type="text" value={customPackageName} onChange={e=>setCustomPackageName(e.target.value)} placeholder="e.g. Honeymoon Package" /></div>
   <div>{lbl('Custom Package Amount (Rs)')}<input style={inp} type="number" min={0} value={customPackageAmount} onChange={e=>setCustomPackageAmount(parseFloat(e.target.value)||0)} /></div>
 </div>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, margin:'16px 0 12px', textTransform:'uppercase', letterSpacing:'.05em' }}>GST Settings</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:8 }}>
   <div>{lbl('GST Mode')}<select style={sel} value={gstMode} onChange={e=>setGstMode(e.target.value)}><option style={{background:'#0F2040',color:'#F0F2FF'}} value="split">Split (Food + Service)</option><option style={{background:'#0F2040',color:'#F0F2FF'}} value="single">Single Rate</option></select></div>
   {gstMode === 'single' && <div>{lbl('GST Single Rate %')}<input style={inp} type="number" min={0} value={gstSingleRate} onChange={e=>setGstSingleRate(parseFloat(e.target.value)||12)} /></div>}
 </div>
 {gstMode === 'split' && (
   <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:8 }}>
     <div>{lbl('Food GST %')}<input style={inp} type="number" min={0} value={gstFoodPct} onChange={e=>setGstFoodPct(parseFloat(e.target.value)||5)} /></div>
     <div>{lbl('Food Portion %')}<input style={inp} type="number" min={0} max={100} value={gstFoodShare} onChange={e=>setGstFoodShare(parseFloat(e.target.value)||70)} /></div>
     <div>{lbl('Service GST %')}<input style={inp} type="number" min={0} value={gstServicePct} onChange={e=>setGstServicePct(parseFloat(e.target.value)||18)} /></div>
   </div>
 )}
 <div style={{ fontSize:11, color:C.text3, marginBottom:12 }}>Default: {gstFoodPct}% on {gstFoodShare}% food portion + {gstServicePct}% on {100-gstFoodShare}% service portion</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div>
 {lbl('Discount Amount')}
 <div style={{ padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:C.amber, fontSize:14, fontWeight:700 }}>{inr(discAmt)}</div>
 </div>
 </div>
 {approvalRequired && (
 <div style={{ marginTop:12, padding:'10px 14px', background:C.amberBg, border:`1px solid ${C.amberBorder}`, borderRadius:8, color:C.amber, fontSize:13 }}>
 Discount above {maxDisc}% requires Resort Manager approval. Contact your manager before proceeding.
 </div>
 )}
 </div>

 {/* Advance */}
 <div style={{ background:C.surface2, borderRadius:12, padding:18, marginBottom:20 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:14 }}> Advance Payment</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div>{lbl('Advance Paid (₹)')}<input style={inp} type="number" min={0} value={advance} onChange={e=>setAdvance(parseFloat(e.target.value)||0)} /></div>
 <div>
 {lbl('Balance Due')}
 <div style={{ padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:C.red, fontSize:14, fontWeight:700 }}>{inr(total-advance)}</div>
 </div>
 </div>
 </div>

 {/* Notes */}
 <div>
 {lbl('Notes / Special Instructions')}
 <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Special requirements, dietary needs, etc."
 style={{ ...inp, height:80, resize:'vertical' }} />
 </div>
 </div>
 )}
 </div>

 {/* Footer */}
 <div style={{ display:'flex', justifyContent:'space-between', padding:'16px 24px', borderTop:'1px solid rgba(255,255,255,.08)' }}>
 <div>{step>1 && <button onClick={()=>setStep(s=>s-1)} style={{ padding:'10px 20px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:14 }}>← Back</button>}</div>
 <div style={{ display:'flex', gap:10 }}>
 <button onClick={onClose} style={{ padding:'10px 20px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:14 }}>Cancel</button>
 {step<3
 ? <button onClick={goNext} style={{ padding:'10px 24px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:14, fontWeight:700 }}>Next →</button>
 : <button onClick={handleSave} disabled={saving||approvalRequired}
 style={{ padding:'10px 24px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:14, fontWeight:700, opacity:(saving||approvalRequired)?.6:1 }}>
 {saving?'Creating…':' Confirm Booking'}
 </button>
 }
 </div>
 </div>
 </div>
 </div>
 );
}

// ── EDIT MODAL ────────────────────────────────────────────────────────────────
function EditModal({ booking, onClose, onSave }) {
  const BOOKINGS_API = 'https://api.botanix.in/api/bookings';
  const nights = booking.start_date && booking.end_date
    ? Math.max(1, Math.round((new Date(booking.end_date) - new Date(booking.start_date)) / 86400000))
    : 1;

  const [form, setForm] = React.useState({
    start_date: booking.start_date ? new Date(booking.start_date).toISOString().slice(0,10) : '',
    end_date: booking.end_date ? new Date(booking.end_date).toISOString().slice(0,10) : '',
    pax_count: booking.pax_count || 1,
    booking_status: booking.booking_status || 'Confirmed',
    total_amount: booking.total_amount || 0,
    advance_paid: booking.advance_paid || 0,
    balance_amount: booking.balance_amount || 0,
    salesperson: booking.salesperson || '',
    booking_type: booking.booking_type || '',
    source: booking.source || '',
    notes: booking.notes || '',
    nationality: booking.nationality || 'Indian',
    children_below5: booking.children_below5 || 0,
    children_6to15: booking.children_6to15 || 0,
    child_rate: booking.child_rate || 60,
    pet_count: booking.pet_count || 0,
    pet_rate: booking.pet_rate || 500,
    day_outing_pax: booking.day_outing_pax || 0,
    day_outing_rate: booking.day_outing_rate || 1500,
    custom_package_name: booking.custom_package_name || '',
    custom_package_amount: booking.custom_package_amount || 0,
    gst_amount: booking.gst_amount || 0,
    gst_breakdown: booking.gst_breakdown || '',
    discount_pct: booking.discount_pct || 0,
  });

  const [activeTab, setActiveTab] = React.useState('basic');
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState('');
  const [rooms, setRooms] = React.useState([]);
  const [bookedRooms, setBookedRooms] = React.useState([]);
  const [loadingRooms, setLoadingRooms] = React.useState(false);
  const [selectedRooms, setSelectedRooms] = React.useState([]);
  const [roomSearch, setRoomSearch] = React.useState('');
  const [filterType, setFilterType] = React.useState('');

  const set = (k,v) => setForm(p=>({...p,[k]:v}));

  const inr = n => '₹' + Number(Math.round(n)||0).toLocaleString('en-IN');

  // Load rooms when rooms tab opened
  React.useEffect(() => {
    if (activeTab === 'rooms') {
      loadRooms();
    }
  }, [activeTab, form.start_date, form.end_date]);

  const loadRooms = async () => {
    setLoadingRooms(true);
    try {
      const [availRes, bookedRes] = await Promise.all([
        fetch(`${BOOKINGS_API}/rooms-available?start_date=${form.start_date}&end_date=${form.end_date}&booking_id=${booking.id}`).then(r=>r.json()),
        fetch(`${BOOKINGS_API}/${booking.id}/rooms`).then(r=>r.json()),
      ]);
      setRooms(Array.isArray(availRes)?availRes:[]);
      setBookedRooms(Array.isArray(bookedRes)?bookedRes:[]);
      setSelectedRooms(Array.isArray(bookedRes)?bookedRes.map(r=>({room_id:r.room_id,room_number:r.room_number,room_name:r.room_name,room_type:r.room_type,rate:r.rate||r.base_tariff||0})):[]);
    } catch(e) { console.error(e); }
    setLoadingRooms(false);
  };

  const toggleRoom = (room) => {
    const exists = selectedRooms.find(r=>r.room_id===room.id);
    if (exists) {
      setSelectedRooms(p=>p.filter(r=>r.room_id!==room.id));
    } else {
      setSelectedRooms(p=>[...p, {
        room_id: room.id,
        room_number: room.room_number,
        room_name: room.room_name,
        room_type: room.room_type,
        rate: parseFloat(room.base_tariff||0),
      }]);
    }
  };

  const updateRoomRate = (roomId, rate) => {
    setSelectedRooms(p=>p.map(r=>r.room_id===roomId?{...r,rate:parseFloat(rate||0)}:r));
  };

  const roomTypes = [...new Set(rooms.map(r=>r.room_type).filter(Boolean))];
  const filteredRooms = rooms.filter(r=>
    (!roomSearch || r.room_number?.toLowerCase().includes(roomSearch.toLowerCase()) || r.room_type?.toLowerCase().includes(roomSearch.toLowerCase())) &&
    (!filterType || r.room_type===filterType)
  );

  const handleSave = async () => {
    setSaving(true); setError('');
    try {
      const res = await fetch(`${BOOKINGS_API}/${booking.id}`, {
        method:'PUT', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          ...form,
          balance_amount: parseFloat(form.total_amount||0) - parseFloat(form.advance_paid||0),
        })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error||'Failed');

      // Save room allocations if on rooms tab or if rooms selected
      if (selectedRooms.length > 0) {
        await fetch(`${BOOKINGS_API}/${booking.id}/rooms`, {
          method:'PUT', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ rooms: selectedRooms, start_date: form.start_date, end_date: form.end_date })
        });
      }

      onSave(); onClose();
    } catch(err) { setError(err.message); }
    finally { setSaving(false); }
  };

  const TABS = [
    {id:'basic', label:'Basic Info'},
    {id:'rooms', label:'Rooms'},
    {id:'guests', label:'Guests'},
    {id:'charges', label:'Charges'},
    {id:'payment', label:'Payment'},
  ];

  const inp = {width:'100%',padding:'9px 12px',background:'#F3F6F3',border:'1.5px solid #CDD8CD',borderRadius:8,color:'#1A2E1E',fontSize:13,boxSizing:'border-box'};
  const lbl = t => <div style={{fontSize:11,fontWeight:700,color:'#7A9A80',textTransform:'uppercase',letterSpacing:'.05em',marginBottom:5}}>{t}</div>;

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.6)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:16,overflowY:'auto'}}>
      <div style={{background:'#fff',borderRadius:16,width:'100%',maxWidth:720,maxHeight:'92vh',overflowY:'auto',padding:28}}>
        {/* Header */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:'#1A2E1E'}}>Edit Booking — {booking.booking_code}</div>
            <div style={{fontSize:12,color:'#7A9A80',marginTop:2}}>{booking.guest_name} · {nights} night(s)</div>
          </div>
          <button onClick={onClose} style={{background:'#F3F6F3',border:'1px solid #CDD8CD',borderRadius:8,padding:'6px 14px',cursor:'pointer',color:'#3D5E44'}}>Close</button>
        </div>

        {/* Tabs */}
        <div style={{display:'flex',gap:4,marginBottom:20,background:'#F3F6F3',borderRadius:10,padding:4}}>
          {TABS.map(t=>(
            <button key={t.id} onClick={()=>setActiveTab(t.id)}
              style={{flex:1,padding:'8px',background:activeTab===t.id?'#3AAF58':'transparent',color:activeTab===t.id?'#fff':'#3D5E44',border:'none',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer'}}>
              {t.label}
            </button>
          ))}
        </div>

        {error && <div style={{padding:'10px 14px',background:'#FDEAEA',color:'#C83333',borderRadius:8,marginBottom:14,fontSize:13}}>{error}</div>}

        {/* BASIC TAB */}
        {activeTab==='basic' && (
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div>{lbl('Check-in Date')}<input style={inp} type="date" value={form.start_date} onChange={e=>set('start_date',e.target.value)} /></div>
            <div>{lbl('Check-out Date')}<input style={inp} type="date" value={form.end_date} onChange={e=>set('end_date',e.target.value)} /></div>
            <div>{lbl('Guests (Pax)')}<input style={inp} type="number" value={form.pax_count} onChange={e=>set('pax_count',e.target.value)} /></div>
            <div>{lbl('Booking Status')}<select style={inp} value={form.booking_status} onChange={e=>set('booking_status',e.target.value)}>
              {['Confirmed','Tentative','Checked In','Checked Out','Cancelled','No Show'].map(s=><option key={s}>{s}</option>)}
            </select></div>
            <div>{lbl('Booking Type')}<input style={inp} value={form.booking_type} onChange={e=>set('booking_type',e.target.value)} /></div>
            <div>{lbl('Source')}<select style={inp} value={form.source} onChange={e=>set('source',e.target.value)}>
              {['Direct','OTA','Corporate','Referral','Walk-in','Phone','WhatsApp','Website','Other'].map(s=><option key={s}>{s}</option>)}
            </select></div>
            <div>{lbl('Salesperson')}<input style={inp} value={form.salesperson} onChange={e=>set('salesperson',e.target.value)} /></div>
            <div>{lbl('Nationality')}<select style={inp} value={form.nationality} onChange={e=>set('nationality',e.target.value)}>
              {['Indian','Foreign'].map(s=><option key={s}>{s}</option>)}
            </select></div>
            <div style={{gridColumn:'span 2'}}>{lbl('Notes')}<textarea style={{...inp,height:70,resize:'vertical'}} value={form.notes} onChange={e=>set('notes',e.target.value)} /></div>
          </div>
        )}

        {/* ROOMS TAB */}
        {activeTab==='rooms' && (
          <div>
            <div style={{padding:'12px 14px',background:'#EAF7EE',borderRadius:10,marginBottom:14,fontSize:13,color:'#3D5E44',border:'1px solid #3AAF5833'}}>
              Select rooms for this booking. Dates: <strong>{form.start_date}</strong> to <strong>{form.end_date}</strong>
            </div>

            {/* Currently selected rooms */}
            {selectedRooms.length > 0 && (
              <div style={{marginBottom:16}}>
                <div style={{fontSize:12,fontWeight:700,color:'#3D5E44',marginBottom:8,textTransform:'uppercase'}}>Selected Rooms ({selectedRooms.length})</div>
                {selectedRooms.map(r=>(
                  <div key={r.room_id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 14px',background:'#EAF7EE',borderRadius:8,marginBottom:6,border:'1px solid #3AAF5833'}}>
                    <div>
                      <span style={{fontWeight:700,color:'#1A2E1E'}}>Room {r.room_number}</span>
                      {r.room_name && <span style={{color:'#7A9A80',fontSize:12}}> — {r.room_name}</span>}
                      <span style={{color:'#7A9A80',fontSize:11,marginLeft:8}}>{r.room_type}</span>
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                      <input type="number" value={r.rate} onChange={e=>updateRoomRate(r.room_id,e.target.value)}
                        style={{...inp,width:90,padding:'5px 8px'}} placeholder="Rate/night" />
                      <span style={{fontSize:11,color:'#7A9A80'}}>/night = {inr(r.rate*nights)}</span>
                      <button onClick={()=>toggleRoom({id:r.room_id})}
                        style={{padding:'4px 8px',background:'#FDEAEA',color:'#C83333',border:'none',borderRadius:6,cursor:'pointer',fontSize:11}}>Remove</button>
                    </div>
                  </div>
                ))}
                <div style={{textAlign:'right',padding:'8px 14px',fontWeight:800,color:'#3AAF58',fontSize:14}}>
                  Rooms Total: {inr(selectedRooms.reduce((s,r)=>s+parseFloat(r.rate||0)*nights,0))}
                </div>
              </div>
            )}

            {/* Available rooms */}
            <div style={{display:'flex',gap:8,marginBottom:10}}>
              <input value={roomSearch} onChange={e=>setRoomSearch(e.target.value)} placeholder="Search rooms..."
                style={{...inp,flex:1}} />
              <select value={filterType} onChange={e=>setFilterType(e.target.value)}
                style={{...inp,width:180}}>
                <option value="">All Types</option>
                {roomTypes.map(t=><option key={t}>{t}</option>)}
              </select>
            </div>

            {loadingRooms ? (
              <div style={{textAlign:'center',padding:30,color:'#7A9A80'}}>Loading rooms...</div>
            ) : (
              <div style={{border:'1px solid #E2E8E2',borderRadius:10,overflow:'hidden',maxHeight:350,overflowY:'auto'}}>
                <table style={{width:'100%',borderCollapse:'collapse'}}>
                  <thead>
                    <tr style={{background:'#F3F6F3',position:'sticky',top:0}}>
                      {['','Room #','Name','Type','Rate/Night','Status'].map(h=>(
                        <th key={h} style={{padding:'9px 12px',textAlign:'left',fontSize:11,fontWeight:700,color:'#7A9A80',textTransform:'uppercase'}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRooms.map((room,i)=>{
                      const isSelected = !!selectedRooms.find(r=>r.room_id===room.id);
                      const isBooked = room.is_booked;
                      return (
                        <tr key={room.id} style={{borderBottom:'1px solid #E2E8E2',background:isSelected?'#EAF7EE':i%2===0?'#fff':'#F8FAF8',cursor:isBooked?'not-allowed':'pointer'}}
                          onClick={()=>!isBooked&&toggleRoom(room)}>
                          <td style={{padding:'9px 12px'}}>
                            <input type="checkbox" checked={isSelected} onChange={()=>!isBooked&&toggleRoom(room)} disabled={isBooked} />
                          </td>
                          <td style={{padding:'9px 12px',fontWeight:700,color:'#1A2E1E'}}>Room {room.room_number}</td>
                          <td style={{padding:'9px 12px',color:'#7A9A80',fontSize:12}}>{room.room_name||'—'}</td>
                          <td style={{padding:'9px 12px',color:'#3D5E44',fontSize:12}}>{room.room_type||'—'}</td>
                          <td style={{padding:'9px 12px',fontWeight:700,color:'#3AAF58'}}>{inr(room.base_tariff)}</td>
                          <td style={{padding:'9px 12px'}}>
                            <span style={{padding:'2px 8px',borderRadius:99,fontSize:10,fontWeight:700,
                              background:isBooked?'#FDEAEA':room.status==='Vacant Clean'?'#EAF7EE':'#FEF6E7',
                              color:isBooked?'#C83333':room.status==='Vacant Clean'?'#3AAF58':'#D4840F'}}>
                              {isBooked?'Booked':room.status}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {filteredRooms.length===0 && <div style={{textAlign:'center',padding:30,color:'#7A9A80'}}>No rooms found</div>}
              </div>
            )}
          </div>
        )}

        {/* GUESTS TAB */}
        {activeTab==='guests' && (
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div>{lbl('Adults (Pax)')}<input style={inp} type="number" value={form.pax_count} onChange={e=>set('pax_count',e.target.value)} /></div>
            <div>{lbl('Nationality')}<select style={inp} value={form.nationality} onChange={e=>set('nationality',e.target.value)}>{['Indian','Foreign'].map(s=><option key={s}>{s}</option>)}</select></div>
            <div>{lbl('Children Below 5 (Free)')}<input style={inp} type="number" value={form.children_below5} onChange={e=>set('children_below5',e.target.value)} /></div>
            <div>{lbl('Children 6-15')}<input style={inp} type="number" value={form.children_6to15} onChange={e=>set('children_6to15',e.target.value)} /></div>
            <div>{lbl('Child Rate (%)')}<input style={inp} type="number" value={form.child_rate} onChange={e=>set('child_rate',e.target.value)} /></div>
          </div>
        )}

        {/* CHARGES TAB */}
        {activeTab==='charges' && (
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div>{lbl('Pet Count')}<input style={inp} type="number" value={form.pet_count} onChange={e=>set('pet_count',e.target.value)} /></div>
            <div>{lbl('Pet Rate/Night')}<input style={inp} type="number" value={form.pet_rate} onChange={e=>set('pet_rate',e.target.value)} /></div>
            <div>{lbl('Day Outing Pax')}<input style={inp} type="number" value={form.day_outing_pax} onChange={e=>set('day_outing_pax',e.target.value)} /></div>
            <div>{lbl('Day Outing Rate/Pax')}<input style={inp} type="number" value={form.day_outing_rate} onChange={e=>set('day_outing_rate',e.target.value)} /></div>
            <div>{lbl('Custom Package Name')}<input style={inp} value={form.custom_package_name} onChange={e=>set('custom_package_name',e.target.value)} placeholder="e.g. Honeymoon Package" /></div>
            <div>{lbl('Custom Package Amount')}<input style={inp} type="number" value={form.custom_package_amount} onChange={e=>set('custom_package_amount',e.target.value)} /></div>
            <div>{lbl('Discount %')}<input style={inp} type="number" value={form.discount_pct} onChange={e=>set('discount_pct',e.target.value)} /></div>
            <div>{lbl('GST Amount')}<input style={inp} type="number" value={form.gst_amount} onChange={e=>set('gst_amount',e.target.value)} /></div>
            <div style={{gridColumn:'span 2'}}>{lbl('Total Amount')}<input style={{...inp,fontWeight:700,fontSize:16}} type="number" value={form.total_amount} onChange={e=>set('total_amount',e.target.value)} /></div>
          </div>
        )}

        {/* PAYMENT TAB */}
        {activeTab==='payment' && (
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div>{lbl('Total Amount')}<input style={inp} type="number" value={form.total_amount} onChange={e=>{set('total_amount',e.target.value);set('balance_amount',parseFloat(e.target.value||0)-parseFloat(form.advance_paid||0));}} /></div>
            <div>{lbl('Advance Paid')}<input style={inp} type="number" value={form.advance_paid} onChange={e=>{set('advance_paid',e.target.value);set('balance_amount',parseFloat(form.total_amount||0)-parseFloat(e.target.value||0));}} /></div>
            <div>{lbl('Balance Due')}<input style={{...inp,background:'#FDEAEA',fontWeight:700}} type="number" value={parseFloat(form.total_amount||0)-parseFloat(form.advance_paid||0)} readOnly /></div>
            <div>{lbl('Booking Status')}<select style={inp} value={form.booking_status} onChange={e=>set('booking_status',e.target.value)}>
              {['Confirmed','Tentative','Checked In','Checked Out','Cancelled','No Show'].map(s=><option key={s}>{s}</option>)}
            </select></div>
          </div>
        )}

        {/* Footer buttons */}
        <div style={{display:'flex',gap:10,marginTop:24,paddingTop:16,borderTop:'1px solid #E2E8E2'}}>
          <button onClick={handleSave} disabled={saving}
            style={{flex:2,padding:'12px',background:'#3AAF58',color:'#fff',border:'none',borderRadius:10,fontSize:15,fontWeight:700,cursor:'pointer',opacity:saving?.6:1}}>
            {saving?'Saving...':'Save Changes'}
          </button>
          <button onClick={onClose}
            style={{flex:1,padding:'12px',background:'transparent',color:'#3D5E44',border:'1px solid #CDD8CD',borderRadius:10,fontSize:14,cursor:'pointer'}}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

function BookingEngine() {
 const [bookings, setBookings] = useState([]);
  const [payModal, setPayModal] = useState(null);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState('');
 const [search, setSearch] = useState('');
 const [filterStatus, setFilterStatus] = useState('All');
 const [successBooking, setSuccessBooking] = useState(null);
 const [showGroup, setShowGroup] = useState(false);
 const [showWedding, setShowWedding] = useState(false);
 const [showCorporate, setShowCorporate] = useState(false);
 const [showRoomStay, setShowRoomStay] = useState(false);
 const [editRoomStay, setEditRoomStay] = useState(null);
 const [editCorporate, setEditCorporate] = useState(null);
 const [editWedding, setEditWedding] = useState(null);
 const [showAdd, setShowAdd] = useState(false);
 const [editBooking, setEditBooking] = useState(null);
 const [confirmDel, setConfirmDel] = useState(null);
 const [deleting, setDeleting] = useState(null);

 const currentUser = (() => { try { return JSON.parse(localStorage.getItem('botanix_user')); } catch { return null; } })();
 const userRole = (() => { try { return JSON.parse(localStorage.getItem('botanix_user'))?.roleKey||''; } catch { return ''; } })();

 const load = useCallback(async () => {
 setLoading(true); setError('');
 try {
 const r = await fetch(`${API}/bookings`);
 const d = await r.json();
 if (!r.ok) throw new Error(d.error||'Failed');
 setBookings(Array.isArray(d)?d:[]);
 } catch(e) { setError(e.message); }
 finally { setLoading(false); }
 }, []);

 useEffect(() => { load(); }, [load]);

 const handleDelete = async (id) => {
 setDeleting(id);
 try { await fetch(`${API}/bookings/${id}`,{method:'DELETE'}); setBookings(p=>p.filter(b=>b.id!==id)); setConfirmDel(null); }
 catch(e) { alert('Delete failed: '+e.message); }
 finally { setDeleting(null); }
 };

 const isSales = userRole === 'SALES';
 const currentUserName = (() => { try { return JSON.parse(localStorage.getItem('botanix_user'))?.name||''; } catch { return ''; } })();
 let filtered = bookings.filter(b => {
 if (isSales && b.salesperson && b.salesperson.toLowerCase().trim() !== currentUserName.toLowerCase().trim() && !b.salesperson.toLowerCase().includes(currentUserName.toLowerCase().split(' ')[0].toLowerCase())) return false;
 const q = search.toLowerCase();
 return !q || [b.booking_code,b.guest_name,b.company_name,b.booking_type].join(' ').toLowerCase().includes(q);
 });
 if (filterStatus!=='All') filtered = filtered.filter(b=>b.booking_status===filterStatus);

 const totalRev = bookings.reduce((s,b)=>s+parseFloat(b.total_amount||0),0);
 const totalBal = bookings.reduce((s,b)=>s+parseFloat(b.balance_amount||0),0);
 const confirmed = bookings.filter(b=>b.booking_status==='Confirmed').length;

 return (
 <div style={{ padding:24, background:C.bg, minHeight:'100vh', color:C.text, fontFamily:'Inter,sans-serif' }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
 <div>
 <div style={{ fontSize:22, fontWeight:800 }}> Bookings</div>
 <div style={{ fontSize:13, color:C.text2, marginTop:2 }}>{bookings.length} total bookings</div>
 </div>
 <button onClick={()=>setShowAdd(true)} style={{ padding:'10px 20px', background:C.accent, border:'none', borderRadius:10, color:'#fff', cursor:'pointer', fontSize:14, fontWeight:700 }}>+ New Booking</button>
 <button onClick={()=>setShowRoomStay(true)} style={{ padding:'10px 20px', background:'rgba(34,197,94,.2)', border:'1px solid rgba(34,197,94,.4)', borderRadius:10, color:'#22C55E', cursor:'pointer', fontSize:14, fontWeight:700 }}>?? Room Stay</button>
 <button onClick={()=>setShowCorporate(true)} style={{ padding:'10px 20px', background:'rgba(37,99,168,.3)', border:'1px solid rgba(37,99,168,.5)', borderRadius:10, color:'#60A0E0', cursor:'pointer', fontSize:14, fontWeight:700 }}>Corporate Booking</button>
 <button onClick={()=>setShowGroup(true)} style={{ padding:'10px 20px', background:'rgba(34,197,94,.2)', border:'1px solid rgba(34,197,94,.4)', borderRadius:10, color:'#22C55E', cursor:'pointer', fontSize:14, fontWeight:700 }}>Group Booking</button>
 <button onClick={()=>setShowWedding(true)} style={{ padding:'10px 20px', background:'rgba(128,96,192,.3)', border:'1px solid rgba(128,96,192,.5)', borderRadius:10, color:'#B090E0', cursor:'pointer', fontSize:14, fontWeight:700 }}>?? Wedding Booking</button>
 </div>

 <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:14, marginBottom:24 }}>
 {[
 {label:'Total', value:bookings.length, color:C.blueLight},
 {label:'Confirmed', value:confirmed, color:C.green},
 {label:'Revenue', value:inr(totalRev), icon:'₹', color:C.accent},
 {label:'Outstanding',value:inr(totalBal), color:C.amber},
 ].map(s=>(
 <div key={s.label} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:'16px 18px' }}>
 <div style={{ fontSize:20, marginBottom:6 }}>{s.icon}</div>
 <div style={{ fontSize:22, fontWeight:800, color:s.color }}>{s.value}</div>
 <div style={{ fontSize:12, color:C.text2, marginTop:2 }}>{s.label}</div>
 </div>
 ))}
 </div>

 <div style={{ display:'flex', gap:10, marginBottom:20, flexWrap:'wrap' }}>
 <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search guest, booking code..." style={{ ...inp, maxWidth:280, flex:1 }} />
 <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={{ ...sel, width:160 }}>
 <option style={{background:'#0F2040',color:'#F0F2FF'}} value="All">All Status</option>
 {STATUSES.map(s=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={s}>{s}</option>)}
 </select>
 <button onClick={load} style={{ padding:'10px 16px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:13 }}> Refresh</button>
 </div>

 {error && <div style={{ padding:'12px 16px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:10, color:C.red, marginBottom:16, fontSize:13 }}> {error}</div>}
 {loading && <div style={{ textAlign:'center', padding:60, color:C.text2 }}>Loading…</div>}

 {!loading && (
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, overflow:'hidden' }}>
 {filtered.length===0
 ? <div style={{ textAlign:'center', padding:60, color:C.text2 }}>No bookings found</div>
 : (
 <div style={{ overflowX:'auto' }}>
 <table style={{ width:'100%', borderCollapse:'collapse' }}>
 <thead>
 <tr style={{ borderBottom:`1px solid ${C.border}` }}>
 {['Code','Guest','Type','Check-in','Check-out','Pax','Amount','Balance','Status','Salesperson','Actions'].map(h=>(
 <th key={h} style={{ padding:'12px 14px', fontSize:11, color:C.text2, fontWeight:600, textAlign:'left', whiteSpace:'nowrap', textTransform:'uppercase', letterSpacing:'.05em' }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {filtered.map((b,i)=>(
 <tr key={b.id} style={{ borderBottom:'1px solid rgba(255,255,255,.05)', background:i%2===0?'transparent':'rgba(255,255,255,.02)' }}>
 <td style={{ padding:'12px 14px', fontSize:13, fontWeight:700, color:C.accent, whiteSpace:'nowrap' }}>{b.booking_code}</td>
 <td style={{ padding:'12px 14px', fontSize:13 }}>
 <div style={{ fontWeight:600, color:C.text }}>{b.guest_name||b.company_name||'—'}</div>
 <div style={{ fontSize:11, color:C.text3 }}>{b.guest_phone||''}</div>
 </td>
 <td style={{ padding:'12px 14px', fontSize:12, color:C.text2, whiteSpace:'nowrap' }}>{b.booking_type}</td>
 <td style={{ padding:'12px 14px', fontSize:12, color:C.text2, whiteSpace:'nowrap' }}>{fmtDate(b.start_date)}</td>
 <td style={{ padding:'12px 14px', fontSize:12, color:C.text2, whiteSpace:'nowrap' }}>{fmtDate(b.end_date)}</td>
 <td style={{ padding:'12px 14px', fontSize:13, color:C.text, textAlign:'center' }}>{b.pax_count}</td>
 <td style={{ padding:'12px 14px', fontSize:13, color:C.text, whiteSpace:'nowrap' }}>{inr(b.total_amount)}</td>
 <td style={{ padding:'12px 14px', fontSize:13, color:parseFloat(b.balance_amount)>0?C.amber:C.text3, whiteSpace:'nowrap' }}>{inr(b.balance_amount)}</td>
 <td style={{ padding:'12px 14px', whiteSpace:'nowrap' }}>
 <span style={{ padding:'3px 10px', borderRadius:99, fontSize:11, fontWeight:700, background:`${STATUS_COLORS[b.booking_status]||C.text3}22`, color:STATUS_COLORS[b.booking_status]||C.text3 }}>
 {b.booking_status}
 </span>
 </td>
 <td style={{ padding:'12px 14px', fontSize:12, color:C.text2, whiteSpace:'nowrap' }}>{b.salesperson||'—'}</td>
 <td style={{ padding:'12px 14px', whiteSpace:'nowrap' }}>
 <div style={{ display:'flex', gap:6 }}>
 <button onClick={()=>setEditBooking(b)} style={{ padding:'5px 12px', background:'rgba(37,99,168,.2)', border:'1px solid rgba(37,99,168,.4)', borderRadius:6, color:'#3B82F6', cursor:'pointer', fontSize:12, fontWeight:600 }}> Edit</button>
 <button onClick={()=>setPayModal({booking:b,guest:{full_name:b.guest_name,email:b.guest_email,phone:b.guest_phone}})} style={{padding:'5px 12px',background:'rgba(201,168,76,.15)',border:'1px solid rgba(201,168,76,.4)',borderRadius:6,color:'#C9A84C',cursor:'pointer',fontSize:12,fontWeight:600}}>💳 Pay</button>
 <button onClick={()=>{const url='https://www.buddygolfers.com/#guest-portal/'+b.booking_code;navigator.clipboard.writeText(url).then(()=>alert('Guest link copied!\n'+url));}} style={{padding:'5px 12px',background:'rgba(128,96,192,.2)',border:'1px solid rgba(128,96,192,.4)',borderRadius:6,color:'#B090E0',cursor:'pointer',fontSize:12,fontWeight:600}} title='Copy guest link'>??</button>
 <button onClick={()=>setConfirmDel(b)} style={{ padding:'5px 12px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:6, color:C.red, cursor:'pointer', fontSize:12, fontWeight:600 }}></button>
 </div>
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 )}
 </div>
 )}

 {editWedding && <WeddingBooking bookingToEdit={editWedding} onClose={()=>setEditWedding(null)} onSave={load} />}
 {showRoomStay && <RoomStayBooking onClose={()=>setShowRoomStay(false)} onSave={load} />}
 {editRoomStay && <RoomStayBooking bookingToEdit={editRoomStay} onClose={()=>setEditRoomStay(null)} onSave={load} />}
 {successBooking && <BookingSuccessModal booking={successBooking} onClose={()=>setSuccessBooking(null)} />}
 {showGroup && <GroupBooking onClose={()=>setShowGroup(false)} onSaved={load} />}
 {showCorporate && <CorporateBooking onClose={()=>setShowCorporate(false)} onSave={load} />}
 {editCorporate && <CorporateBooking bookingToEdit={editCorporate} onClose={()=>setEditCorporate(null)} onSave={load} />}
 {showWedding && <WeddingBooking onClose={()=>setShowWedding(false)} onSave={load} />}
 {showAdd && <BookingModal onClose={()=>setShowAdd(false)} onSave={load} userRole={userRole} />}
 {editBooking && <EditModal booking={editBooking} onClose={()=>setEditBooking(null)} onSave={load} />}

 {confirmDel && (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.7)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
 <div style={{ background:C.surface, border:`1px solid ${C.redBorder}`, borderRadius:16, padding:28, maxWidth:400, width:'90%' }}>
 <div style={{ fontSize:18, fontWeight:700, marginBottom:8, color:C.text }}>Delete Booking?</div>
 <div style={{ fontSize:14, color:C.text2, marginBottom:20 }}>Delete <strong style={{color:C.text}}>{confirmDel.booking_code}</strong> for <strong style={{color:C.text}}>{confirmDel.guest_name}</strong>?</div>
 <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
 <button onClick={()=>setConfirmDel(null)} style={{ padding:'9px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:14 }}>Cancel</button>
 <button onClick={()=>handleDelete(confirmDel.id)} disabled={deleting===confirmDel.id}
 style={{ padding:'9px 18px', background:C.red, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:14, fontWeight:700 }}>
 {deleting===confirmDel.id?'Deleting…':'Yes, Delete'}
 </button>
 </div>
 </div>
 </div>
 )}
 </div>
 );
}
export default BookingEngine;